import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { t } from "@/i18n";

export default function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const u = await login(email, password);
      toast.success(t("Bienvenido, {name}", { name: u.name }));
      navigate("/");
    } catch (err) {
      setError(errMsg(err));
    } finally { setBusy(false); }
  };

  return (
    <AuthShell>
      <form onSubmit={submit} className="space-y-6" data-testid="login-form">
        <div className="space-y-1">
          <p className="eyebrow">{t("Acceso al panel")}</p>
          <h2 className="font-display text-2xl font-bold">{t("Iniciar sesión")}</h2>
        </div>
        <div className="space-y-2">
          <Label htmlFor="email">{t("Correo")}</Label>
          <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" placeholder="tu@doblerrecords.com" autoComplete="email" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">{t("Contraseña")}</Label>
          <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" autoComplete="current-password" />
        </div>
        {error && <p data-testid="login-error" className="text-sm text-destructive bg-destructive/10 border border-destructive/30 rounded-md px-3 py-2">{error}</p>}
        <Button type="submit" className="w-full" disabled={busy} data-testid="login-form-submit-button">{t(busy ? "Entrando…" : "Entrar")}</Button>
        <p className="text-sm text-muted-foreground text-center">
          {t("¿Eres artista y aún no tienes cuenta?")}{" "}
          <Link to="/registro" className="text-primary font-medium hover:underline" data-testid="go-to-register-link">{t("Crear cuenta")}</Link>
        </p>
      </form>
    </AuthShell>
  );
}
